import React, { ReactNode } from "react";

export interface TabProps {
  testId?: string;
  label: ReactNode;
  defaultActive?: boolean;
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  key: string;
}

export const Tab = ({ children, className, testId }: TabProps) => (
  <div className={className} data-testid={testId}>
    {children}
  </div>
);
